import { processYoutubeDomain } from '#src/app/shared/utils/media';

/**
 * if returns a string, it will be used as the src of the iframe.
 * if returns undefined, the iframe should be removed or replaced with a placeholder.
 */
export function processIframeSrc(src: string): string | undefined {
	return processYoutubeDomain(src);
}
